import joi from 'joi';

export const parseDateJsonDef = joi.object({
	__type: joi.string().valid('Date').required(),
	iso: joi.string().required(),
});
